module.exports = __webpack_public_path__ + "media/icons/reset-icon-black-dba807f9.svg";